import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import '../styles/Header.css';

interface HeaderProps {
  currentPage: 'upload' | 'list';
  onPageChange: (page: 'upload' | 'list') => void;
}

const Header: React.FC<HeaderProps> = ({ currentPage, onPageChange }) => {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to sign out?')) {
      logout();
    }
  };

  if (!user) return null;

  return (
    <header className="app-header">
      <div className="header-container">
        <div className="header-left">
          <h1 className="app-title">🎥 Video Upload App</h1>
        </div>

        <nav className="header-nav">
          <button
            className={`nav-button ${currentPage === 'upload' ? 'active' : ''}`}
            onClick={() => onPageChange('upload')}
          >
            📤 Upload
          </button>
          <button
            className={`nav-button ${currentPage === 'list' ? 'active' : ''}`}
            onClick={() => onPageChange('list')}
          >
            📋 My Videos
          </button>
        </nav>

        <div className="header-right">
          <div className="user-info">
            {user.picture && (
              <img
                src={user.picture}
                alt={user.name}
                className="user-avatar"
              />
            )}
            <div className="user-details">
              <span className="user-name">{user.name}</span>
              <span className="user-email">{user.email}</span>
            </div>
          </div>
          
          <button onClick={handleLogout} className="logout-button">
            🚪 Sign Out
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;